import React, { Component } from 'react';
import { CustomInput, Label, Input,FormGroup, FormFeedback,Form,Button} from 'reactstrap';
import EirModal from '../eir-modal/EirModal';
import EirButton from '../eir-button/EirButton';
import Loading from '../shared/Loading';
import EirRecaptcha from '../eir-recaptcha/EirRecaptcha';
import PubSub from 'pubsub-js';
import Constants from '../../Constants';

class OutOfStockEmail extends Component {
  constructor(props) {
    super(props);
    this.child=React.createRef();

    this.handleSubmit = this.handleSubmit.bind(this);
    this.onEmailChange = this.onEmailChange.bind(this);
    
    this.state = {
      response: null,
      sending: false,
      email: ""
    };
  }

  async handleSubmit(event){
    let form =event.target;
    event.preventDefault();
    event.stopPropagation();

      if (form.checkValidity() != false) {
        this.setState({
          sending: true
        });

        let response = await fetch(form.action , {method: form.method , body: new FormData(form)});
        
        this.setState({
          response: (response.ok ? await response.json() : false),
          sending:false
        });
      } 
      form.classList.add('was-validated');
  }

  onClick = () => {
    PubSub.publish(Constants.eventKeys.eirModalToggled, null); 
  }

  onEmailChange(event){
    this.setState({
      email: event.target.value
    });

    
  }

  reset = () => {
    this.setState({
      response: null
    });
  }

  render() {
    return (
      <div className="out-of-stock-email-container">
        {/* commented for a requirement for eir-2057 */}
        {/* <Button onClick={this.onClick} className="mr-1 mt-1 mb-1 device-out-of-stock-button">
          <span className="out-of-stock-text">{this.props.ctaText}</span>
        </Button> */}
        <EirModal centered={true} ref={this.child}>
          {(this.state.response == null && !this.state.sending) && (
            <div>
              <h4 className="out-of-stock-modal-heading">{this.props.heading}</h4>
              <div>Sorry the <span className="font-weight-bold"> {this.props.selectedVariant.name.charAt(0).toUpperCase() + this.props.selectedVariant.name.slice(1) + " "+ this.props.device.name + " "}</span>{this.props.deviceMessage} </div>
              <div className="pb-3">{this.props.subHeading}</div>
                <Form  action="/store/api/forms/salesforce-lead/" method="post" noValidate={true} className="needs-validation d-flex flex-column align-items-center justify-content-center" id="out-of-stock-form" onSubmit={this.handleSubmit} >
                  <input type="hidden" name="lead_source"  value="emobconfmc" />
                  <input type="hidden" name="handset"  value={this.props.device.name + " " +this.props.selectedVariant.name+ " (SKU: "+this.props.selectedVariant.sku}/>
                  <input type="hidden" name="surname" value="."/>
                  <input type="hidden" name="success_submit"  value=""/>
                  <input type="hidden" name="contactNumberPrefix" value=" "/>
                  <input type="hidden" name="productType"  value="outofstock"/>
                  <div className="out-of-stock-form-input-container">
                  <FormGroup>
                    <Label>Name</Label>
                    <Input name="firstName" pattern= "[a-zA-Z\s]+" type="text" required/>
                    <FormFeedback>Please enter a name</FormFeedback>
                  </FormGroup>
                  <FormGroup>
                    <Label>Email</Label>
                    <Input  type="email"  name="email" onChange= {this.onEmailChange} required/>
                    <FormFeedback>Please enter a valid email address</FormFeedback>
                  </FormGroup>
                  <FormGroup>
                    <Label>Mobile Number</Label>
                    <Input  type="tel" minLength="6"  maxLength="10" pattern="^[0-9-+s()]*$" name="contactNumber"  required/>
                    <FormFeedback>Please enter a valid mobile number</FormFeedback>
                  </FormGroup>
                  
                  <div className="d-flex ml-4 mt-2">
                    <CustomInput  name="accept_tcs" value="true" type="checkbox" id="accept_tcs" label={"I accept the "} required/>
                    <a className="ml-1" href={this.props.termsAndConditionsLink.link} target="_blank">{this.props.termsAndConditionsLink.text}</a>
                    </div>
                  <div className="d-flex justify-content-start">
                    <EirRecaptcha />
                  </div>
                  </div>
                  <div className="mt-4 d-flex justify-content-center">
                    <EirButton
                      color="primary"
                      outline={true}
                      type="button"
                      text="Cancel"
                      className="eir-text-secondary mr-4"
                      onClick={this.onClick}
                    />
                    <EirButton
                      type="button"
                      text="Submit"
                      name="Submit"
                      value="Submit"
                    />
                    </div>
                </Form>
              </div>        
            )}

            {(this.state.response != null && this.state.response.success == true ) && (
              <div>
                <div className="valid-stock-email-success eir-icon icon-success-green"></div>
                <h6 className="text-dark mt-5">{this.props.successHeading}</h6>
                <h4 className="text-secondary mt-4">{this.state.email}</h4>
                <h6 className="text-dark mt-4 mb-5"  >{this.props.successSubHeading}</h6>
                </div>
                )}

            {(this.state.response != null  && (this.state.response.success == false || this.state.response == false)) && (
              <div>
                <div className="failure-image"></div>
                <h3 className="text-secondary mt-4">{this.props.failureHeading}</h3>
                <h6 className="text-dark mt-4 mb-5">{this.props.failureSubHeading}</h6>
               </div>
            )}

            {(this.state.response != null ) && (
              <div>
                <EirButton
                  color="primary"
                  outline={true}
                  type="button"
                  text="Close"
                  name="Close"
                  value="Close"
                  className="eir-text-secondary px-6"
                  onClick={this.onClick}
                />
                <div className="text-dark mt-2"><EirButton onClick={this.reset} text='Reset' type='link'></EirButton></div>   
               </div>
            )}

            {(this.state.sending) && (
              <div>
                <h4 className="text-secondary mt-4">Sending...</h4>
                <Loading />
              </div>
            )}
        
        </EirModal>
      </div>
    );
  }
}

export default OutOfStockEmail;